// https://github.com/championswimmer/vuex-module-decorators

import axios from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import { Campaign } from "@/models/definitions";

@Module
export default class Campaigns extends VuexModule {
  campaigns: Campaign[] = [];

  @Mutation
  setCampaigns(campaigns: Campaign[]) {
    this.campaigns = campaigns;
  }

  @Action({ commit: "setCampaigns" })
  async fetchCampaigns() {
    const response = await axios.get<Campaign[]>(
      process.env.VUE_APP_API_ROOT_URL + "api/campaigns"
    );
    return response.data;
  }

  get allCampaigns() {
    return this.campaigns;
  }

  get allGenericCampaigns() {
    return this.campaigns.filter((campaign) => campaign.id > 1);
  }

  get oneCampaign() {
    return (id: number) => this.campaigns.find((campaign) => campaign.id == id);
  }
}
